import { useQuery, keepPreviousData } from '@tanstack/react-query';
import type { LeaderboardScope, LeaderboardPeriod } from '@proref/types';
import { getLeaderboard } from '../services/leaderboard.service';

// Standings for a scope + period. Keyed by both so the Federation/Global and Period toggles each
// swap cached boards instantly. Short stale window — ranks shift as referees accrue xp/accuracy.
export function useLeaderboardQuery(scope: LeaderboardScope, period: LeaderboardPeriod) {
  return useQuery({
    queryKey: ['leaderboard', scope, period],
    queryFn: () => getLeaderboard(scope, period),
    staleTime: 30_000,
    // Show the previous filter's rows while the new key loads, instead of dropping to a skeleton.
    // This does NOT make data staler: staleTime and invalidation are untouched, so a mutation
    // elsewhere still refetches and replaces this immediately. It only fills the gap where a key
    // change has no cached entry yet — and `isPlaceholderData` lets the page mark it provisional.
    placeholderData: keepPreviousData,
  });
}
